<!-- 报告上传 -->

<template>
  <div class="province-B">
    <div class="ttBar">
      <span>上报国家新闻出版署</span>
    </div>
    <div class="pgContent">
      <!-- disabled="upStateHybg == 'loading'"  -->
      <!-- v-if="ableUpHybg == 1" -->
      <el-upload
        accept=".doc,.docx"
        ref="upload"
        :headers="postHead"
        :disabled="upStateHybg == 'loading'"
        :action="postUrl"
        :before-upload="prevCtrls1"
        :on-progress="pgressCtrls"
        :on-error="errorCtrls"
        :on-success="successCtrls"
        :on-remove="removeCtrls"
        :show-file-list="false"
        :data="{ fileProperty: 1 }"
        multiple
        :on-exceed="handleExceed">
        <el-button>
          <span v-if="upStateHybg == 'loaded' || ableUpZgbg == 2">更新分析报告</span>
          <span v-else-if="upStateHybg == 'loading'">上传中 <i class="el-icon-loading"></i></span>
          <span v-else>上传分析报告</span>
        </el-button>
      </el-upload>

      <!-- zym.去掉限制了 -->
      <div class="flieList" download>
        <a @click="goUrl(fileUrlHybg)" download>{{ fileNameHybg }}</a>
      </div>
      <!-- <div v-if="ableUpHybg == 1" class="flieList" download>
        <a @click="goUrl(fileUrlHybg)" download>{{ fileNameHybg }}</a>
      </div>
      <a v-if="ableUpHybg == 2" @click="goUrl(fileUrlHybg)" download>
        <el-button>下载分析报告</el-button>
      </a> -->
      <!-- 整改报告 -->
      <!-- v-if="ableUpZgbg == 1" -->
      <el-upload
        accept=".doc,.docx"
        ref="upload"
        :headers="postHead"
        :disabled="upStateZgbg == 'loading'"
        :action="postUrl"
        :before-upload="prevCtrls2"
        :on-progress="pgressCtrls"
        :on-error="errorCtrls"
        :on-success="successCtrls"
        :on-remove="removeCtrls"
        :show-file-list="false"
        :data="{ fileProperty: 2 }"
        multiple
        :on-exceed="handleExceed">
        <el-button>
          <span v-if="upStateZgbg == 'loaded' || ableUpZgbg == 2">更新整改报告</span>
          <span v-else-if="upStateZgbg == 'loading'">上传中 <i class="el-icon-loading"></i></span>
          <span v-else>上传整改报告</span>
        </el-button>
      </el-upload>

      <!-- zym.去掉限制了 -->
      <div class="flieList">
        <a @click="goUrl(fileUrlZgbg)" download>{{ fileNameZgbg }}</a>
      </div>
      <!-- <div v-if="ableUpZgbg == 1" class="flieList">
        <a @click="goUrl(fileUrlZgbg)" download>{{ fileNameZgbg }}</a>
      </div>
      <a v-if="ableUpZgbg == 2" @click="goUrl(fileUrlZgbg)" download>
        <el-button>下载整改报告</el-button>
      </a> -->

      <div class="" style="font-size: 14px; margin-top: 15px; line-height: 20px; color: black">
        <!-- <span style="color: red">注：</span>请上传国家出版行政管理部门同意创办的批复文件，如有特殊情况无法上传，
        <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 请对无法上传情况进行说明，上传加盖社章的说明文件。
        <br />  -->
        <!-- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
        上传文件格式为doc、docx，文件大小不超过10M
      </div>
      <div>
        <el-progress
          class="progressBox"
          v-show="upStateHybg == 'loading' || upStateZgbg == 'loading'"
          :stroke-width="9"
          :percentage="percentage">
        </el-progress>
      </div>

      <div v-if="ableUpHybg == 3" class="pvcTips">已上报至总局</div>
    </div>
    <div v-if="ableUpHybg == 1" class="subArea">
      <el-button @click="goAdmin" type="primary">上报国家新闻出版署</el-button>
    </div>
    <div class="" style="margin-top: 1px; margin-left: 20px">
      <div style="color: red; font-size: 20px">若省局已经审核完成，请点击“上报国家新闻出版署”。</div>
      <br />
      <span style="color: black; font-size: 14px"
        >音像电子出版单位年度核验情况报告等材料（含各社登记表）报送方式：</span
      >

      <br />
      <span style="color: black; font-size: 14px"
        >由省级出版行政管理部门统一寄送至以下地址，北京市西城区宣武门外大街40号出版局音像电子处，联系人：郑加可，电话010-83138687</span
      >
    </div>
  </div>
</template>

<script>
import { getToken } from "@/utils/auth";
import {
  stepToAdmin,
  isSubmited,
  successiveReported, // zym.查验状态
  ssReportLoad, // zym.分析报告查询
  getPostponeDesc, // zym.整改报告查询
  ssReportUpload, // zym.更新分析报告
  upPostponeDesc, // zym.更新整改报告
} from "@/api/provinceRole/provinceRole";
import { getFileToken } from "@/api/account";
import { getPfileUrl } from "@/api/pressRole/pressRole";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      percentage: 0, // zym.上传百分比
      upStateHybg: "wait", // zym.上传的状态
      upStateZgbg: "wait", // zym.上传的状态

      fileData: {},
      fileToken: "",

      ableUpHybg: 0, // zym.分析报告
      ableUpZgbg: 0, // zym.整改报告

      reportId: "",

      fileUrlHybg: "",
      fileNameHybg: "",

      fileUrlZgbg: "",
      fileNameZgbg: "",

      postUrl: "",
      postHead: {},
    };
  },

  computed: {
    ...mapGetters(["userInfo"]),
  },

  methods: {
    goUrl: function (url) {
      window.open(url);
    },
    handleExceed: function () {},
    removeCtrls: function () {},
    prevCtrls1: function (file) {
      let nameArr = file.name.split(".");
      let fileType = nameArr[nameArr.length - 1];

      if (fileType != "doc" && fileType != "docx") {
        this.$message({
          message: "请上传格式为 WORD 的文件！",
          type: "error",
        });
        return false;
      }

      if (file.size / 1024 / 1024 > 10) {
        this.$message({
          message: "文件大小不能超过 10M！",
          type: "error",
        });
        return false;
      } else {
        this.percentage = 0;
        this.upStateHybg = "loading";
        // this.fileData.token = getToken();
        this.fileData.fileSize = file.size;

        this.postHead["Authorization"] = `Bearer ${getToken()}`;

        return true;
      }
    },
    prevCtrls2: function (file) {
      let nameArr = file.name.split(".");
      let fileType = nameArr[nameArr.length - 1];

      if (fileType != "doc" && fileType != "docx") {
        this.$message({
          message: "请上传格式为 WORD 的文件！",
          type: "error",
        });
        return false;
      }

      if (file.size / 1024 / 1024 > 10) {
        this.$message({
          message: "文件大小不能超过 10M！",
          type: "error",
        });
        return false;
      } else {
        this.percentage = 0;
        this.upStateZgbg = "loading";
        // this.fileData.token = getToken();
        this.fileData.fileSize = file.size;

        this.postHead["Authorization"] = `Bearer ${getToken()}`;

        return true;
      }
    },
    pgressCtrls: function (evt, file) {
      this.percentage = parseInt(file.percentage);
    },
    errorCtrls: function (err) {
      this.upStateHybg = "wait";
      this.$alert("上传失败，请稍后重试！", "提示", {
        confirmButtonText: "确定",
        type: "error",
      });
    },

    successCtrls: function (data, file) {
      let vm = this;
      this.percentage = 99;
      let newDate = new Date();
      let yearStr = newDate.getFullYear() - 2 + "-" + (newDate.getFullYear() - 1);

      let params = data.data.params;
      console.log("data=", data);
      // console.log('data.data=',JSON.stringify(data.data.params))

      // zym.分析报告
      if (params.fileProperty == 1) {
        ssReportUpload({
          provinceReport: {
            reportId: data.payload.id,
            type: 1,
            status: this.ableUpHybg,
          },
        })
          .then((response) => {
            this.percentage = 100;
            this.upStateHybg = "loaded";
            this.$refs.upload.clearFiles();

            vm.fileNameHybg = data.payload.fileName;
            getPfileUrl({ id: data.payload.id }).then((response) => {
              vm.fileUrlHybg = response.payload.url;
            });

            this.$emit("go-frash");
          })
          .catch((error) => {
            this.$refs.upload.clearFiles();
            this.upStateHybg = "wait";
          });
      }
      // zym.整改报告
      else if (params.fileProperty == 2) {
        upPostponeDesc({
          provinceReport: {
            reportId: data.payload.id,
            type: 1,
            status: this.ableUpZgbg,
          },
        })
          .then((response) => {
            this.percentage = 100;
            this.upStateZgbg = "loaded";
            this.$refs.upload.clearFiles();

            vm.fileNameZgbg = data.payload.fileName;
            getPfileUrl({ id: data.payload.id }).then((response) => {
              vm.fileUrlZgbg = response.payload.url;
            });

            this.$emit("go-frash");
          })
          .catch((error) => {
            this.$refs.upload.clearFiles();
            this.upStateZgbg = "wait";
          });
      }
    },

    // zym.上报国家新闻出版署
    goAdmin: function () {
      let vm = this;
      const loading = vm.$loading({
        lock: true,
        text: "处理中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      stepToAdmin({
        type: 1,
      }).then((response) => {
        loading.close();
        let tipCode = response.payload.tipCode;
        let tipMessage = response.payload.tipMessage || "操作失败";
        if (tipCode == "fail") {
          this.$message({
            showClose: true,
            message: tipMessage,
            type: "error",
          });
        } else {
          this.$message({
            message: tipMessage,
            type: "success",
            onClose: function () {
              vm.$emit("go-frash");
            },
          });
          // this.ableUpHybg = 2;
          // this.ableUpZgbg = 2;
        }
      });
    },

    goFirmSeek: function () {
      let promiseArr = [];
      let vm = this;
      const loading = vm.$loading({
        lock: true,
        text: "状态查询中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      // zym.查询通过状态
      promiseArr.push(
        new Promise((resolve, reiect) => {
          successiveReported({
            type: 1,
          })
            .then((response) => {
              // console.log('response11=',JSON.stringify(response));
              resolve(response);
            })
            .catch((error) => {
              reiect(error);
            });
        })
      );
      // zym.查询分析报告
      promiseArr.push(
        new Promise((resolve, reiect) => {
          ssReportLoad({
            type: 1,
            provinceId: this.userInfo.orgId,
          })
            .then((response) => {
              console.log("response=", JSON.stringify(response));
              resolve(response);
            })
            .catch((error) => {
              reiect(error);
            });
        })
      );

      // zym.整改报告
      promiseArr.push(
        new Promise((resolve, reiect) => {
          getPostponeDesc({
            type: 1,
            provinceId: this.userInfo.orgId,
          })
            .then((response) => {
              // console.log('response=',JSON.stringify(response));
              resolve(response);
            })
            .catch((error) => {
              reiect(error);
            });
        })
      );

      // promiseArr.push(new Promise((resolve, reiect) => {
      //   getFileToken().then(response => {
      //     resolve(response);
      //   }).catch(error => {
      //     reiect(error);
      //   })
      // }));
      Promise.all(promiseArr).then((result) => {
        // console.debug('Promise.all: ', result)
        let isPosted = false; // zym.是否全部通过
        let isUploadHybg = false; // zym.分析报告是否上传
        let isUploadZgbg = false; // zym.分析报告是否上传
        // vm.fileToken = result[2].resultStatus.token;
        console.log("result[0]=", result[0]);
        if (result[0].status == 2) {
          isPosted = true;
        }

        // zym.分析报告
        let provinceReport = result[1].provinceReport;
        // console.log('provinceReport=',JSON.stringify(provinceReport));
        if (provinceReport && provinceReport.reportId) {
          isUploadHybg = true;
          getPfileUrl({ id: provinceReport.reportId }).then((response) => {
            vm.fileUrlHybg = response.payload.url;
            vm.fileNameHybg = response.payload.fileName;
          });
        }

        // zym.整改报告
        let upPostponeDesc = result[2].upPostponeDesc;
        if (upPostponeDesc && upPostponeDesc.reportId) {
          isUploadZgbg = true;
          getPfileUrl({ id: upPostponeDesc.reportId }).then((response) => {
            vm.fileUrlZgbg = response.payload.url;
            vm.fileNameZgbg = response.payload.fileName;
          });
        }

        console.log("isPosted=", isPosted);
        console.log("isUploadHybg=", isUploadHybg);
        console.log("isUploadZgbg=", isUploadZgbg);
        if (isPosted) {
          if (isUploadHybg) {
            vm.ableUpHybg = 2;
          } else {
            vm.ableUpHybg = 3;
          }

          // zym.整改报告
          if (isUploadZgbg) {
            vm.ableUpZgbg = 2;
          } else {
            vm.ableUpZgbg = 3;
          }
        } else {
          vm.ableUpHybg = 1;
          vm.ableUpZgbg = 1;
          if (isUploadHybg) {
            vm.upStateHybg = "loaded";
          }
          if (isUploadZgbg) {
            vm.upStateZgbg = "loaded";
          }
        }

        loading.close();
      });
    },
  },

  created: function () {
    this.goFirmSeek();
    this.postUrl = process.env.BASE_API + "/eavar/file/upload";
  },
};
</script>

<style lang="scss">
.tips {
  margin-top: 10px;
  font-size: 12px;
  color: #999;
}

.province-B {
  padding: 9px;

  .ttBar {
    height: 45px;
    line-height: 45px;
    background: #f8f8f8;
    font-size: 14px;
    padding: 0px 20px;
    color: #666666;
    font-weight: bold;
  }

  .pgContent {
    padding: 20px;
    border-bottom: 1px solid #e8e8e8;

    .el-button {
      width: 168px;
    }

    .progressBox {
      width: 60%;
      margin-top: 12px;
    }

    .flieList {
      font-size: 14px;
      margin-top: 12px;
      margin-bottom: 20px;

      a {
        color: #409eff;
      }
    }
  }

  .subArea {
    padding: 20px;
  }

  .pvcTips {
    padding: 12px 20px;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// commonReport.vue?9ac91d56